import { Button } from '@mui/material';
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';

const LinkButton = ({ children, onClick, href }) => (
    <Button
        href={href}
        onClick={onClick}
        endIcon={<ArrowForwardIosIcon sx={{ fontSize: '0.8rem !important' }} />}
        sx={{
            color: 'primary.main',
            px: 0.5,
            py: 0.5,
            minHeight: 34,
            fontSize: '1.05rem',
            '&:hover': {
                bgcolor: 'transparent',
                textDecoration: 'underline',
            },
        }}
    >
        {children}
    </Button>
);

export default LinkButton;
